import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentApiModels } from 'models/api/payment-api.models';
import { Observable } from 'rxjs';
import { QuotationApiModels } from '../../../../../models/api/quotation-api.models';
import { ConfigurationModels } from '../../../../../models/configuration.models';
import { QuotationModels } from '../../../../../models/quotation.models';
import { TableModels } from '../../../../../models/table.models';
import { ApiServiceBase } from './api-service-base';

@Injectable({ providedIn: 'root' })
export class QuotationApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'quotations');
  }

  getQuotationStatus(
    quotationId: string,
  ): Observable<QuotationModels.QuotationStatusData> {
    return this.getJson(`/${quotationId}/status`);
  }

  getAnonymousQuotationStatus(
    request: QuotationModels.QuotationPaymentCredentials,
  ): Observable<QuotationModels.QuotationStatusData> {
    return this.getJson(
      `/${request.publicId}/clientStatus`,
      { birthDate: request.birthDate },
      { withCredentials: false },
    );
  }

  validateAnonymousSubscription(
    quotationId: string,
    request: QuotationApiModels.AnonymousSubscriptionData,
  ): Observable<PaymentApiModels.PayzenPayload> {
    return this.post(`/${quotationId}/payAnonymous`, request, {
      withCredentials: false,
    });
  }

  validateSubscription(
    quotationId: string,
    request: QuotationApiModels.SubscriptionData,
  ): Observable<PaymentApiModels.PayzenPayload> {
    return this.post(`/${quotationId}/pay`, request);
  }

  getQuotation(
    publicId: string,
    ignoreArchived: boolean,
  ): Observable<QuotationApiModels.QuotationResponse> {
    if (ignoreArchived) {
      return this.getJson(`/${publicId}`, {
        ignoreArchived: ignoreArchived.toString(),
      });
    }

    return this.getJson(`/${publicId}`);
  }

  getAnonymousQuotation(
    request: QuotationModels.QuotationPaymentCredentials,
  ): Observable<QuotationApiModels.QuotationResponse> {
    return this.getJson(
      `/${request.publicId}/clientSummary`,
      { birthDate: request.birthDate },
      { withCredentials: false },
    );
  }

  getCanPay(
    request: QuotationModels.QuotationPaymentCredentials,
  ): Observable<void> {
    return this.getJson(
      `/${request.publicId}/canPay`,
      { birthDate: request.birthDate },
      { withCredentials: false },
    );
  }

  createQuotation(
    request: QuotationApiModels.CreateQuotationRequest,
  ): Observable<string> {
    return this.post('/', request);
  }

  getCarPricing(
    request: QuotationApiModels.AutomobileQuotationRequest,
  ): Observable<QuotationApiModels.PricingResponse> {
    return this.post('/cars/pricing', request);
  }

  getCarPricingWithMetadata(
    request: QuotationApiModels.AutomobileQuotationRequest,
  ): Observable<QuotationApiModels.CarPricingWithMetadataResponse> {
    return this.post('/cars/pricingwithmetadata', request);
  }

  getQuotationList(request: TableModels.PaginatedRequest) {
    return this.getJson<
      TableModels.PaginatedResult<QuotationApiModels.QuotationTableRow>
    >('', { ...request });
  }

  archiveQuotation(quotationId: number) {
    return this.post(`/${quotationId}/archive`, {});
  }
}
